function shopifyUrl(path) {
  // Ensure path does not start with a slash
  if (path.startsWith("/")) path = path.substring(1);
  return window.Shopify.routes.root + path;
}

export { shopifyUrl };
